import { ApiCaller } from 'common/helpers/apiCaller';
import { convertToQueryStringNew2 } from 'common/helpers/convertToQueryString';

// ------ Access Management List ------ //
export const accessManagementService = (data: object, page: string | number, size: string | number) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/access-management/transaction/${page}/${size}?${convertToQueryStringNew2(data)}`
  });
};

// ------ Area List ------ //
export const areaListService = () => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/access-management/areas`
  });
};
